<template>
  <div>
    <b-row>
      <b-col cols="5">
        <h1>{{ titleSetting }}</h1>
      </b-col>
      <b-col cols="7">
        <div class="d-flex" v-if="type == 3">
          <b-input-group class="panel-input-serach">
            <b-form-input
              id="product-search"
              class="input-serach"
              placeholder="ค้นหาอีเมล"
              v-model="form.search"
              @keyup.enter="getListUser"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="icon-input m-auto pr-2" @click="getListUser">
                <font-awesome-icon icon="search" title="View" />
              </span>
            </b-input-group-prepend>
          </b-input-group>
          <b-button class="btn-main ml-2" @click="changeStep(4, false)">
            <span class="d-none d-sm-inline">สร้าง</span>
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div class="body-setting" :class="type != null && 'active'">
      <div v-if="type == null">
        <b-row>
          <b-col cols="12" lg="4" md="6">
            <div class="box-detail" @click="changeStep(1, false)">
              <div class="bg-icon">
                <b-icon icon="file-text"></b-icon>
              </div>
              <p class="m-0 text-bold">
                ตั้งค่าใบปะหน้า
                <br />
                <span class="text-description">
                  ตั้งค่าขนาดของใบปะหน้า
                </span>
              </p>
            </div>
          </b-col>
          <b-col cols="12" lg="4" md="6">
            <div class="box-detail" @click="changeStep(2, false)">
              <div class="bg-icon">
                <b-icon icon="clock"></b-icon>
              </div>
              <p class="m-0 text-bold">
                ตั้งค่ารอบบิล / แบทช์
                <br />
                <span class="text-description">
                  ตั้งค่ารอบเวลาสำหรับสร้างบิลและแบทช์
                </span>
              </p>
            </div>
          </b-col>
          <b-col cols="12" lg="4" md="6">
            <div class="box-detail" @click="changeStep(3, false)">
              <div class="bg-icon">
                <b-icon icon="people-fill"></b-icon>
              </div>
              <p class="m-0 text-bold">
                สร้างผู้ใช้งาน
                <br />
                <span class="text-description">
                  สร้างผู้ใช้งานสำหรับ Warehouse
                </span>
              </p>
            </div>
          </b-col>
        </b-row>
      </div>

      <SettingPaper @cancel="cancel" v-if="type == 1" />
      <SettingBatch @cancel="cancel" v-if="type == 2" />
      <SettingUser
        @cancel="cancel"
        @changeForm="changeForm"
        @editUser="editUser"
        :form="form"
        :items="items"
        :rows="rows"
        :busy="isBusy"
        v-if="type == 3"
      />
      <CreateUser
        @cancel="cancel"
        @backStep="backStep"
        @openModalText="openModalText"
        v-if="type == 4"
        :edit="edit"
        :dataEdit="dataEdit"
      />
    </div>
    <ModalText :textModal="textModal" :unCheck="unCheck" />
  </div>
</template>

<script>
import ModalText from "@/views/pages/setting/modal/ModalText";
import SettingPaper from "@/views/pages/setting/component/settingPaper.vue";
import SettingBatch from "@/views/pages/setting/component/settingBatch.vue";
import SettingUser from "@/views/pages/setting/component/settingUser.vue";
import CreateUser from "@/views/pages/setting/component/createUser.vue";

export default {
  components: {
    ModalText,
    SettingPaper,
    SettingBatch,
    SettingUser,
    CreateUser,
  },
  data() {
    return {
      form: {
        pageNo: 1,
        perPage: 10,
        search: "",
        status: [0, 1],
      },

      items: [],
      rows: 10,

      dataEdit: {},

      // state check
      edit: false,
      type: null,
      isBusy: false,

      // state modal
      textModal: "",
      unCheck: false,
    };
  },
  watch: {
    type(val) {
      if (val == 3) {
        this.getListUser();
      }
    },
  },
  computed: {
    titleSetting() {
      let text = "";

      if (this.type == 1) {
        text = "ตั้งค่าใบปะหน้า";
      } else if (this.type == 2) {
        text = "ตั้งค่ารอบบิล / แบทช์";
      } else if (this.type == 3) {
        text = "รายการผู้ใช้งาน";
      } else if (this.type == 4) {
        text = "รายละเอียด";
      } else {
        text = "ตั้งค่า";
      }

      return text;
    },
  },
  methods: {
    getListUser() {
      this.isBusy = true;

      this.axios
        .post(`${this.$baseUrl}/account/List`, this.form)
        .then((result) => {
          if (result.result == 1) {
            this.items = result.detail.userProfileList;
            this.rows = this.calculateRows(result.detail.count);

            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editUser(obj) {
      this.dataEdit = obj;
      this.edit = true;

      this.type = 4;
    },
    changeStep(step, statusEdit) {
      this.type = step;
      this.edit = statusEdit;
    },
    calculateRows(count) {
      // find number rows
      let findRows = count / this.form.perPage;

      // use for check .00 and + 1
      findRows = Math.ceil(findRows);

      let finalRows = findRows * 10;

      return finalRows;
    },
    changeForm(form) {
      this.form = form;
      this.getListUser();
    },
    backStep() {
      this.type = 3;
    },
    openModalText(obj) {
      const { textModal, unCheck } = obj;
    
      this.textModal = textModal;
      this.unCheck = unCheck;
      this.$bvModal.show("modal-text");
    },
    cancel() {
      this.type = null;
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.onSubmitFilter();
      }
    },
  },
};
</script>

<style scoped>
.body-setting {
  height: calc(100vh - 220px);
  background: white;
  padding: 20px;
  border-radius: 8px;
}
.body-setting.active {
  display: flex;
}
.box-detail {
  display: flex;
  align-items: center;
  max-height: 40px;
  padding: 10px 0px;
  margin-bottom: 15px;
  cursor: pointer;
}
.text-description {
  font-size: 13px;
  font-weight: normal;
}
.bg-icon {
  /* overrides class */
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #b41bb4;
  min-height: 40px;
  border-radius: 8px;
  margin-right: 5px;
  width: 45px;
  height: 45px;
}

.btn-save {
  background: #b41bb4;
  color: white !important;
  border-radius: 8px;
  min-width: 120px;
  border: none;
}

/* overrides b-icon*/
.b-icon {
  color: white;
  font-size: 20px;
}
</style>
